import React from 'react'
import "./ServicesCard.css"
import { useNavigate } from 'react-router-dom'

const servicesDataOld = [
    {
      icon:"/images/icons/Group-1330.svg",
      img:"/images/creative/service-card-1.jpg",
      title:"Outsourced Accounting ",
      content:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard"
    },
    {
      icon:"/images/icons/Group-1331.svg",
      title:"Payroll Services",
      content:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard"
    },
    {
      icon:"/images/icons/Group-1332.svg",
      title:"Bookkeeping Services",
      content:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard"
    },
    {
      icon:"/images/icons/Group-1333.svg",
      title:"Personal Tax and Filing",
      content:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard"
    },
    {
      icon:"/images/icons/Group-1334.svg",
      title:"Business Tax Preparation",
      content:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard"
    },
    {
      icon:"/images/icons/Group-1335.png",
      title:"Tax Planning and Strategy",
      content:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard"
    },
    {
      icon:"/images/icons/Group-1336.svg",
      title:"International Tax Services",
      content:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard"
    },
    {
      icon:"/images/icons/Group-1337.svg",
      title:"Business Consulting",
      content:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard"
    },
  ]
const servicesData = [
    {
      icon:"/images/icons/Group-1330.svg",
      img:"/images/creative/service-card-1.jpg",
      title:"Accounting & Bookkeeping ",
      link:"/accounting-taxes#accountingbookkeeping",
      content:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard"
    },
    {
      icon:"/images/icons/Group-1331.svg",
      img:"/images/creative/service-card-2.jpg",
      title:"Personal & Corporate Tax",
      link:"/accounting-taxes#personalcorpratetax",
      content:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard"
    },
    {
      icon:"/images/icons/Group-1332.svg",
      img:"/images/creative/service-card-3.jpg",
      title:"Compilation Engagement Report",
      link:"/accounting-taxes#accountingbookkeeping",
      content:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard"
    },
    {
      icon:"/images/icons/Group-1333.svg",
      img:"/images/creative/service-card-4.jpg",
      title:"Payroll Services",
      link:"/accounting-taxes#accountingbookkeeping",
      content:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard"
    },
    {
      icon:"/images/icons/Group-1334.svg",
      img:"/images/creative/service-card-5.jpg",
      title:"Financial Statements & Analysis",
      link:"/consulting-services#financialstatement",
      content:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard"
    },
    {
      icon:"/images/icons/Group-1335.png",
      img:"/images/creative/service-card-6.webp",
      title:"Budgeting & Forecasting",
      link:"/consulting-services#budgetforecasting",
      content:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard"
    },
    {
      icon:"/images/icons/Group-1336.svg",
      img:"/images/creative/service-card-7.jpg",
      title:"Business Plan & Cash Flow",
      link:"/consulting-services#bussinessplan",
      content:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard"
    },
    {
      icon:"/images/icons/Group-1337.svg",
      img:"/images/creative/service-card-8.jpg",
      title:"Business Incorporation",
      link:"/consulting-services#bussinessincorpration",
      content:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard"
    },
  ]

function ServicesCard() {
  const navigate = useNavigate()
  return (
    <div className="ServicesCard-container standard-padding-space">
      <div className="container ">
        <div className="row ">
          <div className="col-sm-12 text-center mb-5 mt-4 text-content">
            <h3 className="body-heading color-white">DISCOVER OUR SERVICES</h3>
            {/* <p className="body-paragraph mt-3 color-white">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer.
            </p> */}
          </div>
          <div className="col-sm-12">
            <div className="container mt-4">
              <div className="row gy-4 justify-content-center">
                {servicesData.map((ele, ind) => {
                  return (
                    <div className="col-lg-4 col-md-4 col-sm-6 col-12">
                      <div
                        className="discover-card-box mx-auto " 
                        style={{backgroundImage:`url('${ele?.img}')`}}
                        // onMouseOver={() => {
                        //   setHoverEffect(ind);
                        // }}
                        // onMouseLeave={() => {
                        //   setHoverEffect(-1);
                        // }}
                      >
                        <div className='overlay'></div>
                        <div className='content-box px-lg-2 px-2 d-flex text-start flex-column align-items-start justify-content-center'>
                          <h5
                            className="card-title color-white pb-4"
                          //   style={
                          //     hoverEffect == ind
                          //       ? { color: "white" }
                          //       : { color: "grey" }
                          //   }
                          >
                            {ele.title}
                          </h5>
                          {/* <p className="card-content color-white py-3">{ele.content}</p> */}
                          <p className='color-white' style={{ textTransform: "uppercase",cursor:"pointer" }} onClick={()=>{navigate(ele?.link)}}>learn more</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServicesCard